import './style.css'


const Timeline = ({ timelineData = [], TimelineCardComp }) => {
  return (
    <div className="timeline-container">
      {timelineData.map((data, idx) => (
        <TimelineItem TimelineCard={TimelineCardComp} data={data} key={idx} />
      ))}
    </div>
  )
};

const TimelineItem = ({ data, TimelineCard }) => (
  <div className="timeline-item">
    <div className="timeline-item-content">
      <TimelineCard {...data} />
    </div>
    <span className="circle"></span>
  </div>
);

export default Timeline;